import { createSlice } from "@reduxjs/toolkit";
import { format } from "date-fns";

import TYPE from "../../constants/SearchBar";
import { calculateDateRange } from "../timeFunctions";

const localTimeRange = localStorage.getItem("tiles-timeRange");

const initialState = {
	searchPhrase: localStorage.getItem("tiles-searchPhrase") || "",
	timeRange: localTimeRange || TYPE.option1,
	accountType: JSON.parse(localStorage.getItem("tiles-accountType")) || [],
	startDate:
		localStorage.getItem("tiles-startDate") || format(new Date(), "yyyy-MM-dd"),
	endDate:
		localStorage.getItem("tiles-endDate") || format(new Date(), "yyyy-MM-dd"),
	predefinedDates: localTimeRange
		? calculateDateRange(localTimeRange)["predefinedDates"]
		: calculateDateRange(TYPE.option1)["predefinedDates"],
	selectedTileId: localStorage.getItem("tiles-selectedTileId") || "today",
	splitType: localStorage.getItem("tiles-splitType") || "month",
	// lastUpdate: format(new Date(), "yyyy-MM-dd"),
	selectedProductIds:
		JSON.parse(localStorage.getItem("tiles-selectedProductIds")) || [],
	excludedProductIds:
		JSON.parse(localStorage.getItem("tiles-excludedProductIds")) || [],
	isAllProductsSelected:
		localStorage.getItem("tiles-isAllProductsSelected") === "true"
			? true
			: false,
	searchItemsTotal: localStorage.getItem("tiles-searchItemsTotal") || 0,
};

export const tilesSearchSlice = createSlice({
	name: "tilesSearchStore",
	initialState,
	reducers: {
		// set search phrase
		setSearchPhrase(state, action) {
			state.searchPhrase = action.payload;
			localStorage.setItem("tiles-searchPhrase", action.payload);
		},
		// set time range
		setTimeRange(state, action) {
			state.timeRange = action.payload;
			localStorage.setItem("tiles-timeRange", action.payload);
		},
		// set account type
		setAccountType(state, action) {
			state.accountType = action.payload;
			localStorage.setItem("tiles-accountType", JSON.stringify(action.payload));
		},
		// set start date
		setStartDate(state, action) {
			state.startDate = action.payload;
			localStorage.setItem("tiles-startDate", action.payload);
		},
		// set end date
		setEndDate(state, action) {
			state.endDate = action.payload;
			localStorage.setItem("tiles-endDate", action.payload);
		},
		// set predefined dates
		setPredefinedDates(state, action) {
			state.predefinedDates = action.payload;
			localStorage.setItem(
				"tiles-predefinedDates",
				JSON.stringify(action.payload)
			);
		},
		// set selected tile Id
		setSelectedTileId(state, action) {
			state.selectedTileId = action.payload;
			localStorage.setItem("tiles-selectedTileId", action.payload);
		},
		// set split type
		setSplitType(state, action) {
			state.splitType = action.payload;
			localStorage.setItem("tiles-splitType", action.payload);
		},
		// set last update
		// setLastUpdate(state, action) {
		// 	state.lastUpdate = action.payload;
		// },
		// set selected product Ids
		setSelectedProductIds(state, action) {
			state.selectedProductIds = action.payload;
			localStorage.setItem(
				"tiles-selectedProductIds",
				JSON.stringify(action.payload)
			);
		},
		// set excluded product Ids
		setExcludedProductIds(state, action) {
			state.excludedProductIds = action.payload;
			localStorage.setItem(
				"tiles-excludedProductIds",
				JSON.stringify(action.payload)
			);
		},
		// set is all products selected
		setIsAllProductsSelected(state, action) {
			state.isAllProductsSelected = action.payload;
			localStorage.setItem("tiles-isAllProductsSelected", action.payload);
		},
		// set search items total
		setSearchItemsTotal(state, action) {
			state.searchItemsTotal = action.payload;
			localStorage.setItem("tiles-searchItemsTotal", action.payload);
		},
		// reset products search
		resetProductsSearch(state) {
			state.searchPhrase = "";
			localStorage.setItem("tiles-searchPhrase", "");
			state.selectedProductIds = [];
			localStorage.setItem("tiles-selectedProductIds", "[]");
			state.excludedProductIds = [];
			localStorage.setItem("tiles-excludedProductIds", "[]");
			state.isAllProductsSelected = false;
			localStorage.setItem("tiles-isAllProductsSelected", "false");
			state.searchItemsTotal = 0;
			localStorage.setItem("tiles-searchItemsTotal", 0);
		},
		// set range related data
		setRangeData(state, action) {
			state.timeRange = action.payload.timeRange;
			localStorage.setItem("tiles-timeRange", action.payload.timeRange);
			state.startDate = action.payload.startDate;
			localStorage.setItem("tiles-startDate", action.payload.startDate);
			state.endDate = action.payload.endDate;
			localStorage.setItem("tiles-endDate", action.payload.endDate);
			state.predefinedDates = action.payload.predefinedDates;
			localStorage.setItem(
				"tiles-predefinedDates",
				JSON.stringify(action.payload.predefinedDates)
			);
			state.splitType = action.payload.splitType;
			localStorage.setItem("tiles-splitType", action.payload.splitType);
			state.selectedTileId = action.payload.selectedTileID;
			localStorage.setItem(
				"tiles-selectedTileId",
				action.payload.selectedTileID
			);
		},
		// set state when account type is changed
		setAccountTypeAndResetProducts(state, action) {
			state.accountType = action.payload;
			localStorage.setItem("tiles-accountType", JSON.stringify(action.payload));
			state.selectedProductIds = [];
			localStorage.setItem("tiles-selectedProductIds", "[]");
			state.excludedProductIds = [];
			localStorage.setItem("tiles-excludedProductIds", "[]");
			state.isAllProductsSelected = false;
			localStorage.setItem("tiles-isAllProductsSelected", "false");
			state.searchPhrase = "";
			localStorage.setItem("tiles-searchPhrase", "");
		},
		// reset everything and clear local storage
		resetStore(state) {
			state.searchPhrase = "";
			localStorage.removeItem("tiles-searchPhrase");
			state.timeRange = TYPE.option1;
			localStorage.removeItem("tiles-timeRange");
			state.accountType = [];
			localStorage.removeItem("tiles-accountType", "[]");
			state.startDate = format(new Date(), "yyyy-MM-dd");
			localStorage.removeItem("tiles-startDate");
			state.endDate = format(new Date(), "yyyy-MM-dd");
			localStorage.removeItem("tiles-endDate");
			state.predefinedDates = calculateDateRange(TYPE.option1)[
				"predefinedDates"
			];
			localStorage.removeItem("tiles-predefinedDates");
			state.selectedTileId = "today";
			localStorage.removeItem("tiles-selectedTileId");
			state.splitType = "month";
			localStorage.removeItem("tiles-splitType");
			state.selectedProductIds = [];
			localStorage.removeItem("tiles-selectedProductIds");
			state.excludedProductIds = [];
			localStorage.removeItem("tiles-excludedProductIds");
			state.isAllProductsSelected = false;
			localStorage.removeItem("tiles-isAllProductsSelected");
			state.searchItemsTotal = 0;
			localStorage.setItem("tiles-searchItemsTotal", 0);
		},
		// handle state when tile selected
		setSelectedTile(state, action) {
			state.selectedTileId = action.payload.tileId;
			localStorage.setItem("tiles-selectedTileId", action.payload.tileId);
			state.startDate = action.payload.startDate;
			localStorage.setItem("tiles-startDate", action.payload.startDate);
			state.endDate = action.payload.endDate;
			localStorage.setItem("tiles-endDate", action.payload.endDate);
		},
	},
});

export const tilesSearchSliceActions = tilesSearchSlice.actions;
export default tilesSearchSlice.reducer;
